var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHub = function SvgHub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hub_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 1.661,
    r: 1.585,
    fill: "url(#hub_svg__b)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 1.661,
    r: 1.496,
    stroke: "#fff",
    strokeOpacity: 0.27,
    strokeWidth: 0.178
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 14.339,
    r: 1.585,
    fill: "url(#hub_svg__c)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 14.339,
    r: 1.496,
    stroke: "#fff",
    strokeOpacity: 0.27,
    strokeWidth: 0.178
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.547,
    cy: 4.83,
    r: 1.585,
    fill: "url(#hub_svg__d)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.547,
    cy: 4.83,
    r: 1.496,
    stroke: "#fff",
    strokeOpacity: 0.27,
    strokeWidth: 0.178
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.453,
    cy: 4.83,
    r: 1.585,
    fill: "url(#hub_svg__e)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.453,
    cy: 4.83,
    r: 1.496,
    stroke: "#fff",
    strokeOpacity: 0.27,
    strokeWidth: 0.178
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.547,
    cy: 11.17,
    r: 1.585,
    fill: "url(#hub_svg__f)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.547,
    cy: 11.17,
    r: 1.496,
    stroke: "#fff",
    strokeOpacity: 0.27,
    strokeWidth: 0.178
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.453,
    cy: 11.17,
    r: 1.585,
    fill: "url(#hub_svg__g)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.453,
    cy: 11.17,
    r: 1.496,
    stroke: "#fff",
    strokeOpacity: 0.27,
    strokeWidth: 0.178
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hub_svg__h)",
    d: "m6.745 4.042-2.738 6.26H6.23l.419-1.004H9.38l.418 1.003H12.1l-2.845-6.26h-2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311D46",
    d: "M8.745 7.373h-1.5L8 5.699l.745 1.674Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hub_svg__b",
    x1: 8,
    x2: 8,
    y1: 0.076,
    y2: 3.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F62092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hub_svg__c",
    x1: 8,
    x2: 8,
    y1: 12.754,
    y2: 15.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F62092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hub_svg__d",
    x1: 13.547,
    x2: 13.547,
    y1: 3.246,
    y2: 6.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F62092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hub_svg__e",
    x1: 2.453,
    x2: 2.453,
    y1: 3.246,
    y2: 6.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F62092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hub_svg__f",
    x1: 13.547,
    x2: 13.547,
    y1: 9.585,
    y2: 12.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F62092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hub_svg__g",
    x1: 2.453,
    x2: 2.453,
    y1: 9.585,
    y2: 12.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F62092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hub_svg__h",
    x1: 8,
    x2: 9.954,
    y1: 4.042,
    y2: 18.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hub_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgHub;